// DashboardRoutes.js
import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "../view/global/Sidebar"; 
import Topbar from "../view/global/Topbar";
import { Box } from "@mui/system";
import Dashboard from "../view/dashboard/dashboard";
import MemberView from "../view/dashboard/MemberView";
import UserList from "../view/dashboard/UserList";
import MemberList from "../view/dashboard/MemberList";
import MemberConflicts from "../view/dashboard/MemberConflicts";
import AdminAuditLog from "../view/dashboard/AdminAuditLog";
import UserAuditLog from "../view/dashboard/UserAuditLog";
import DammaSermensRequest from "../view/dashboard/DammaSermens";
import DanaAtHome from "../view/dashboard/DanaAtHome";
import DanaBreakfastRequestsAnnual from "../view/dashboard/DanaBreakfastRequestsAnnual";
import DanaLunchRequestsAnnual from "../view/dashboard/DanaLunchRequestsAnnual";
import DanaBreakfastAvailability from "../view/dashboard/DanaBreakfastAvailability";
import DanaLunchAvailability from "../view/dashboard/DanaLunchAvailability";
import DanaBreakfastPaymentRequests from "../view/dashboard/DanaBreakfastPaymentRequests";
import DanaLunchPaymentRequests from "../view/dashboard/DanaLunchPaymentRequests";
import DanaBreakfastRequests from "../view/dashboard/DanaBreakfastRequests";
import DanaLunchRequests from "../view/dashboard/DanaLunchRequests";
import DanaGilanpasaRequests from "../view/dashboard/DanaGilanpasaRequests";
import DanaGilanpasaAvailability from "../view/dashboard/DanaGilanpasaAvailability";
import DanaPirikaraRequests from "../view/dashboard/DanaPirikaraRequests";
import DanaPirikaraItems from "../view/dashboard/DanaPirikaraItems";
import ExternalGlen from "../view/dashboard/ExternalGlen";
import ExternalHallam from "../view/dashboard/ExternalHallam";
import ExternalPackenham from "../view/dashboard/ExternalPackenham";
import FeaturePlan from "../view/dashboard/FeaturePlan";
import FiveYear from "../view/dashboard/FiveYear";
import EventView from "../view/dashboard/EventView";
import KatinaRequests from "../view/dashboard/KatinaRequest";
import InternalRetreatOrg from "../view/dashboard/InternalRetreatOrg";
import SoloRetreatOnline from "../view/dashboard/SoloRetreatOnline";
import SoloRetreatReg from "../view/dashboard/SoloRetreatReg";
import GuestSpeakerReq from "../view/dashboard/GuestSpeaketReq";
import SuttaView from "../view/dashboard/SuttaView";
import ParittaAtHome from "../view/dashboard/ParittaAtHome";
import InternalRetreatReg from "../view/dashboard/InternalRetreatReg";
import InternalRetreatReq from "../view/dashboard/InternalRetreatReq";
import GuestSpeakerReg from "../view/dashboard/GuestSpeakerReg";
import OrdinationReq from "../view/dashboard/OrdinationReq";
import OrdinationReg from "../view/dashboard/OrdinationReg";
import IndividualPooja from "../view/dashboard/IndividualPooja";
import LandLotRequest from "../view/dashboard/LandLotRequest";
import FiveYearMem from "../view/dashboard/FiveYearMem";
import FiveYearReq from "../view/dashboard/FiveYearReq";
import RequestOngoingReq from "../view/dashboard/RequestOngoingReq";
import MaintenanceReq from "../view/dashboard/MaintanceReq";
import MaintenanceFundReq from "../view/dashboard/MaintenanceFundReq";
import HealthFound from "../view/dashboard/HealthFound";
import LifeLongMembershipsReq from "../view/dashboard/LifelongMembershipReq";
import LifeLongMembership from "../view/dashboard/LifeLongMembership";
import BuildingFund from "../view/dashboard/BuildingFund";
import SangaFund from "../view/dashboard/SangaFund";
import AnnualExFundReq from "../view/dashboard/AnnualExpenseFundReq";
import AnnualExMem from "../view/dashboard/AnnualExpenseFundMember";
import General from "../view/dashboard/Genral";
import RetreatView from "../view/dashboard/RetreatView";
import ContactSettings from "../view/dashboard/ContactSettings";

const DashboardRoutes = () => {
  const [isSidebar, setIsSidebar] = useState(true);

  return (
    <Box className="app" display="flex" sx={{ minHeight: '100vh', width: '100%', overflowX: 'auto' }}>
      <Sidebar isSidebar={isSidebar} setIsSidebar={setIsSidebar} />

      <Box
        component="main"
        flexGrow={1}
        p={3}
        sx={{
          width: '100%',
          overflowX: 'auto',
          marginLeft: isSidebar ? "20px" : "0px",
          transition: "margin-left 0.3s ease-in-out",
        }}
      >
        <Topbar setIsSidebar={setIsSidebar} />

        <Routes>
          <Route path="/" element={<Navigate to="/admin/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="memeberView" element={<MemberView/>} />
          <Route path="userList" element={<UserList/>} />
          <Route path="memberList" element={<MemberList/>} />
          <Route path="memberConflicts" element={<MemberConflicts/>} />
          <Route path="adminAudit" element={<AdminAuditLog/>} />
          <Route path="userAudit" element={<UserAuditLog/>} />
          <Route path="dammaSermens" element={<DammaSermensRequest/>} />
          <Route path="danaathome" element={<DanaAtHome/>} />
          <Route path="breakfast-dana-annual-requests" element={<DanaBreakfastRequestsAnnual/>} />
          <Route path="Lunch-dana-annual-requests" element={<DanaLunchRequestsAnnual />} />
          <Route path="breakfast-dana-payment-requests" element={<DanaBreakfastPaymentRequests/>} />
          <Route path="lunch-dana-payment-requests" element={<DanaLunchPaymentRequests/>} />   
          <Route path="breakfast-dana-requests" element={<DanaBreakfastRequests/>} />
          <Route path="lunch-dana-requests" element={<DanaLunchRequests/>} />                
          <Route path="breakfast-availability" element={<DanaBreakfastAvailability/>} />
          <Route path="lunch-availability" element={<DanaLunchAvailability/>} />
          <Route path="dana-gilanpasa" element={<DanaGilanpasaRequests/>} />
          <Route path="dana-gilanpasa-availability" element={<DanaGilanpasaAvailability/>} />
          <Route path="dana-pirikara-requests" element={<DanaPirikaraRequests/>} />
          <Route path="dana-pirikara-items" element={<DanaPirikaraItems/>} />
          <Route path="exGlen" element={<ExternalGlen/>} />
          <Route path="exHallam" element={<ExternalHallam/>} />
          <Route path="exPackenham" element={<ExternalPackenham/>} />
          <Route path="featurePlan" element={<FeaturePlan/>} />
          <Route path="fiveYear" element={<FiveYear/>} />
          <Route path="event" element={<EventView/>} />
          <Route path="katina" element={<KatinaRequests/>} />
          <Route path="inReOrg" element={<InternalRetreatOrg/>} />
          <Route path="SoloReOnline" element={<SoloRetreatOnline/>} />
          <Route path="SoloReReg" element={<SoloRetreatReg/>} />
          <Route path="GuestSpReg" element={<GuestSpeakerReq/>} />
          <Route path="SuttaView" element={<SuttaView/>} />
          <Route path="ParittaAtHome" element={<ParittaAtHome/>} />          
          <Route path="inReg" element={<InternalRetreatReg/>} />
          <Route path="inReq" element={<InternalRetreatReq/>} />
          <Route path="GuestSpRegi" element={<GuestSpeakerReg/>} />
          <Route path="ordinationReq" element={<OrdinationReq/>} />
          <Route path="ordinationReg" element={<OrdinationReg/>} />
          <Route path="inPReq" element={<IndividualPooja/>} />
          <Route path="landLot" element={<LandLotRequest/>} />
          <Route path="fiveYearMem" element={<FiveYearMem/>} />
          <Route path="fiveYearReq" element={<FiveYearReq/>} />
          <Route path="ongoingReq" element={<RequestOngoingReq/>} />
          <Route path="maintainReq" element={<MaintenanceReq/>} />
          <Route path="maintainceFoundRquest" element={<MaintenanceFundReq/>} />
          <Route path="sangaHealthFound" element={<HealthFound/>} />
          <Route path="lifeLongReq" element={<LifeLongMembershipsReq/>} />
          <Route path="lifeLongMem" element={<LifeLongMembership/>} />
          <Route path="buildingFund" element={<BuildingFund/>} />
          <Route path="sangaFund" element={<SangaFund/>} />
          <Route path="annualReq" element={<AnnualExFundReq/>} />
          <Route path="annualMemReq" element={<AnnualExMem/>} />
          <Route path="general" element={<General/>} />
          <Route path="createInt" element={<RetreatView/>} />
          <Route path="contact-settings" element={<ContactSettings/>} /> {/* Add this new route */}
        </Routes>
      </Box>
    </Box>
  );
};

export default DashboardRoutes;